import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getCaptcha, refreshCaptcha, validateSignUp, getContentData, getMatchedLanguageData } from '../../../Redux/UsersData/Actions/UsersAction';
import './SignUpPage.scss';
import { WEBSOURCEID, SOURCESYSTEMCODE } from '../../../Constant/Common.const.js';
import { glassboxErrorEvent, glassboxSuccessEvent } from '../../Service/Glassbox';
import { GET_CAPTCHA_AUDIO, WEBSOURCESID, MFEAPIURL } from '../../../Config/Api.route.config';

function SignUp() {

    const [firstName, updateFirstName] = useState("");
    const [lastName, updateLastName] = useState("");
    const [emailAddress, updateEmailAddress] = useState("");
    const [confirmEmailAddress, updateConfirmEmailAddress] = useState("");
    const [imageSource, setimageSource] = useState("");
    const [firstNameError, setFirstNameError] = useState("");
    const [lastnameError, setLastnameError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [emailErrorSignUp, setEmailErrorSignUp] = useState("");
    const [confirmEmailError, setConfirmEmailError] = useState("");
    const [confirmEmailErrorSignUp, setConfirmEmailErrorSignUp] = useState("");
    const [matchEmailError, setMatchEmailError] = useState("");
    const [matchEmailErrorSignUp, setMatchEmailErrorSignUp] = useState("");
    const [captchaError, setCaptchaError] = useState("");
    const [signUpSuccess, setSignUpSuccess] = useState("");
    const [signUpError, setSignUpError] = useState("");
    const [validateSignUpFlag, setvalidateSignUpFlag] = useState(false);
    const [isEnabled, setisEnabled] = useState(true);
    const [loadingFlag, setLoadingFlag] = useState(false);
    const [showPrivacyText, setShowPrivacyText] = useState(false);
    // const [showConsent, setShowConsent] = useState(false);
    const [consent, setConsent] = useState(false);
    const dispatch = useDispatch();

    const emailValidator = /^(([^+<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const gmailValidator = /^[a-zA-Z0-9.!#$%&'*=?^_`{|}~-][^+]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i
    const nameValidator = /^\s*([^<>{}:+]\s*){1,150}$/;

    const queryString = window.location.search;
    let country = undefined;
    let language = undefined;
    let segment = undefined;
    let sourcePage = undefined;
    const urlParams = new URLSearchParams(queryString);
    country = encodeURIComponent(urlParams.get('c'));
    language = encodeURIComponent(urlParams.get('l'));
    segment = encodeURIComponent(urlParams.get('s'));
    sourcePage = encodeURIComponent(urlParams.get('ref'));
    if (language === 'null' || language.length > 2) {
        language = 'en';
    }
    else if (!language) {
        language = 'en';
    }

    if (country === 'null' || country.length > 2) {
        country = 'us';
    }
    else if (!country) {
        country = 'us';
    }

    if (segment === 'null' || segment.length > 3) {
        segment = 'dhs';
    }
    else if (!segment) {
        segment = 'dhs';
    }
    if (sourcePage === 'null' || sourcePage.length === 0) {
        sourcePage = 'PMC_SIGNUP';
    }


    //inject script in dom
    useEffect(() => {
        const script = document.createElement('script');
        script.src = MFEAPIURL;
        document.body.appendChild(script);
        console.log(script);
        document.querySelector('dell-pmc-ncm').addEventListener('PmcNcmConsentValueChanged', (e) => {
            setConsent(e.detail.isAllRequiredConsentsCollected);
        }, false);

        return () => {
            document.body.removeChild(script);
        }
    }, []);

    useEffect(() => {
        dispatch(getCaptcha());
        dispatch(getContentData(country, language));
        dispatch(getMatchedLanguageData(country, language));
    }, [country, language]);

    useEffect(() => {
        checksubmitbutton();
    }, [emailError, confirmEmailError, imageSource, matchEmailError, emailErrorSignUp, confirmEmailErrorSignUp, matchEmailErrorSignUp,
        emailAddress, confirmEmailAddress, firstName, lastName, firstNameError, lastnameError, consent]);

    const allData = useSelector((state) => state.users.users);
    let imageSrc = allData.image ? "data: image/png;base64," + allData.image : "";
    const validateSignUp_response = useSelector((state) => state.users.validateSignUp);
    const contentData = useSelector((state) => state.users.contentData)

    const renderTextLabel = (filterItem) => {
        if (contentData.length > 0) {
            let filteredText = contentData.filter((u) => u.key === filterItem)[0];
            if (typeof (filteredText) !== 'undefined' && filteredText != null) {
                return filteredText.value.microContentValue;
            } else {
                return '';
            }
        }
        else {
            return '';
        }
    }

    const SignUpPayload = {
        "firstName": firstName,
        "lastName": lastName,
        "email": emailAddress,
        "segment": segment,
        "urlCountryCode": country,
        "urlLanguageCode": language,
        "websourceId": WEBSOURCEID,
        "campaignId": "",
        "transactionGuid": "",
        "sourceSystemCode": SOURCESYSTEMCODE,
        "key": allData.key,
        "input": imageSource,
        "sourcePage": sourcePage,
        "pmcTraceId": renderTextLabel("pmcTraceId")
    }

    const handlerefreshCaptcha = () => {
        let key = allData.key;
        dispatch(refreshCaptcha(key));
    }

    const handleCaptchaAudio = () => {
        var audio = document.getElementById('audio')
        if (audio) {
            audio.src = GET_CAPTCHA_AUDIO + "/" + allData.key;
            audio.play().catch(function (error) {
                console.error(error)
                glassboxErrorEvent(error);
            });
        }
    }


    const firstName_fn = (event) => {
        updateFirstName(event.target.value);
        setSignUpSuccess("");
        setSignUpError("");
    }

    const lastName_fn = (event) => {
        updateLastName(event.target.value);
        setSignUpSuccess("");
        setSignUpError("");
    }

    const emailAddress_fn = (event) => {
        updateEmailAddress(event.target.value);
        validateEmailSignUp(event.target.value);
        setCaptchaError("");
        setSignUpSuccess("");
        setSignUpError("");
    }

    const confirmEmailAddress_fn = (event) => {
        updateConfirmEmailAddress(event.target.value);
        validateConfirmEmailSignUp(event.target.value);
        setCaptchaError("");
        setSignUpSuccess("");
        setSignUpError("");
    }

    const validateCaptcha_fn = (event) => {
        setimageSource(event.target.value);
        setSignUpSuccess("");
        setSignUpError("");
        if (event.target.value.length < 3 || event.target.value.length > 8) {
            setisEnabled(true);
        }

    }

    const validateFirstName = (event) => {
        if (nameValidator.test(firstName)) {
            setFirstNameError("");
        }
        else {
            if (firstName.length > 0) {
                setFirstNameError(renderTextLabel("esp_email_Label_FirstNameError_Text"));
                glassboxErrorEvent("missing first name");
            } else {
                setFirstNameError(renderTextLabel(""));
            }
        }
    }

    const validateLasttName = (event) => {
        if (nameValidator.test(lastName)) {
            setLastnameError("");
        }
        else {
            if (lastName.length > 0) {
                setLastnameError(renderTextLabel("esp_email_Label_LastNameError_Text"));
                glassboxErrorEvent("missing last name");
            } else {
                setLastnameError(renderTextLabel(""));
            }
        }
    }

    const validateEmail = (event) => {
        const email_address = emailAddress;
        const confirm_email_address = confirmEmailAddress;

        if (emailValidator.test(email_address)) {
            setEmailError("");
        }
        else {
            setEmailError(renderTextLabel("esp_email_Label_EmailError_Text"));
            glassboxErrorEvent("invalid email address");
        }
        if (email_address !== confirm_email_address && email_address.length !== 0 && confirm_email_address.length !== 0 && confirmEmailError.length === 0) {
            setMatchEmailError(renderTextLabel("esp_email_Label_EmailMatchError_Text"));
            glassboxErrorEvent("mismatch of email address");
        }
        else {
            setMatchEmailError("");
        }
    }

    const validateEmailSignUp = (email) => {
        if (emailValidator.test(email)) {
            setEmailError("");
            setEmailErrorSignUp("");
        }
        else {
            setEmailErrorSignUp(renderTextLabel("esp_email_Label_EmailError_Text"));
            glassboxErrorEvent("invalid email address");
        }
        if (email !== confirmEmailAddress && email.length !== 0 && confirmEmailAddress.length !== 0) {
            setMatchEmailErrorSignUp(renderTextLabel("esp_email_Label_EmailMatchError_Text"));
            glassboxErrorEvent("mismatch of email address");
        }
        else {
            setMatchEmailErrorSignUp("");
        }
    }

    const validateConfirmEmail = (event) => {
        const email_address = emailAddress;
        const confirm_email_address = confirmEmailAddress;
        if (emailValidator.test(confirm_email_address)) {
            setConfirmEmailError("")
        } else {
            setConfirmEmailError(renderTextLabel("esp_email_Label_EmailError_Text"));
            glassboxErrorEvent("invalid email address");
        }
        if (email_address !== confirm_email_address && email_address.length !== 0 && confirm_email_address.length !== 0 && emailError.length === 0) {
            setMatchEmailError(renderTextLabel("esp_email_Label_EmailMatchError_Text"));
            glassboxErrorEvent("mismatch of email address");
        }
        else {
            setMatchEmailError("");
        }
    }

    const validateConfirmEmailSignUp = (confirmEmail) => {
        if (emailValidator.test(confirmEmail)) {
            setConfirmEmailErrorSignUp("")
        }
        else {
            setConfirmEmailErrorSignUp(renderTextLabel("esp_email_Label_EmailError_Text"));
            glassboxErrorEvent("invalid email address");
        }
        if (emailAddress !== confirmEmail && emailAddress.length !== 0 && confirmEmail.length !== 0 && emailError.length === 0) {
            setMatchEmailErrorSignUp(renderTextLabel("esp_email_Label_EmailMatchError_Text"));
            glassboxErrorEvent("mismatch of email address");
        }
        else {
            setMatchEmailErrorSignUp("");
        }
    }
    const clearState = () => {
        document.querySelectorAll("#firstName")[0].value = "";
        document.querySelectorAll("#lastName")[0].value = "";
        document.querySelectorAll("#emailAddress")[0].value = "";
        document.querySelectorAll("#confirmEmailAddress")[0].value = "";
        document.querySelectorAll("#captchaText")[0].value = "";
        updateFirstName("");
        updateLastName("");
        updateEmailAddress("");
        updateConfirmEmailAddress("");
        setimageSource("");
        handlerefreshCaptcha();
    };



    const validateCaptchaFormat = (event) => {
        const image_source = imageSource;
        if (image_source.length < 5 || image_source.length > 7) {
            setisEnabled(true);
        }
    }

    const handleValidateCaptcha = () => {
        setLoadingFlag(true);
        dispatch(validateSignUp(SignUpPayload, ""));
    }

    if (validateSignUp_response && validateSignUp_response.message === "User signed up successfully.") {
        setSignUpSuccess(renderTextLabel("esp_email_Label_Success_Text"));
        glassboxSuccessEvent("sign up completed successfully");
        setLoadingFlag(false);
        clearState();
        setisEnabled(true);
        dispatch(validateSignUp(SignUpPayload, "none"));
    } else if (validateSignUp_response && validateSignUp_response.message === "Captcha validation failed") {
        setvalidateSignUpFlag(true);
        setisEnabled(true);
        handlerefreshCaptcha();
        setimageSource("");
        setCaptchaError(renderTextLabel("esp_email_Label_CaptchaInvalid_Text"));
        glassboxErrorEvent("invalid captcha");
        document.querySelectorAll("#captchaText")[0].value = "";
        dispatch(validateSignUp(SignUpPayload, "none"));
        setLoadingFlag(false);

    } else if (validateSignUp_response && validateSignUp_response.message === "Bad Email") {
        setSignUpError(renderTextLabel("esp_email_Label_EmailError_Text"));
        glassboxErrorEvent("invalid email address");
        setLoadingFlag(false);
        clearState();
        dispatch(validateSignUp(SignUpPayload, "none"));
    } else if (validateSignUp_response && validateSignUp_response.statusCode === 500) {
        setSignUpError(renderTextLabel("esp_email_InvalidSignUp_Error_Text"));
        glassboxErrorEvent("got 500 error");
        setLoadingFlag(false);
        clearState();
        dispatch(validateSignUp(SignUpPayload, "none"));
    }

    const checksubmitbutton = () => {
        if (emailValidator.test(confirmEmailAddress) && emailValidator.test(emailAddress) && emailAddress === confirmEmailAddress) {
            setMatchEmailError("");
            setEmailError("");
            setConfirmEmailError("");
        }
        if (imageSource.length >= 5 && imageSource.length <= 7) {
            if (emailError.length === 0 && confirmEmailError.length === 0 && matchEmailError.length === 0 && emailAddress.length !== 0 && confirmEmailAddress.length !== 0
                && imageSource.length !== 0 && emailErrorSignUp.length === 0 && matchEmailErrorSignUp.length === 0 && confirmEmailErrorSignUp.length === 0
                && emailAddress === confirmEmailAddress && firstNameError.length === 0 && lastnameError.length === 0 && consent) {
                setisEnabled(false);
                setFirstNameError("");
                setLastnameError("");
                setMatchEmailError("");
                setEmailError("");
                setConfirmEmailError("");
                setCaptchaError("");

            } else {
                setisEnabled(true)
            }
        }
    }

    return (
        <div>
            <div className="dds__wrapper">

                <div className="dds__container containerDiv dds__p-0 dds__m-0">

                    <div className="signup-form dds__row dds__p-0 dds__m-0">
                        <div className="dds__col--md-12 headerDiv dds__m-0">
                            <div className="header-content-mobile">
                                <div className="dds__row">
                                    <h1>{renderTextLabel("esp_email_header_signUp_text")}</h1>
                                </div>
                                <div className="dds__row">
                                    <p className="newsletter-text">{renderTextLabel("esp_email_newsletter_signUp_text")}</p>
                                    <p><br /><br /><br /><br /><br /></p>
                                </div>
                            </div>
                            <div className="header-content">
                                <div className="dds__col--md-8">
                                    <div className="dds__row">
                                        <h2>{renderTextLabel("esp_email_header_signUp_text")}</h2>
                                    </div>
                                    <div className="dds__row">
                                        <p className="newsletter-text">{renderTextLabel("esp_email_newsletter_signUp_text")}</p>
                                        <p><br /><br /><br /><br /></p>
                                    </div>
                                </div>
                                <div className="dds__col--md-4 imgDiv">
                                    <div className="dds__row headerbcg"></div>
                                </div>
                            </div>
                        </div>
                        <div className="dds__container formDiv">
                            {firstNameError !== "" ? <div className='dds__message-bar dds__message-bar--warning Email_error'><div className="dds__message-bar__icon">
                                <i className="dds__icon dds__icon--alert-notice"></i>
                            </div>{firstNameError}</div> : ""}

                            {lastnameError !== "" ? <div className='dds__message-bar dds__message-bar--warning Email_error'><div className="dds__message-bar__icon">
                                <i className="dds__icon dds__icon--alert-notice"></i>
                            </div>{lastnameError}</div> : ""}

                            {emailError !== "" ? <div className='dds__message-bar dds__message-bar--warning Email_error'><div className="dds__message-bar__icon">
                                <i className="dds__icon dds__icon--alert-notice"></i>
                            </div>{emailError}</div> : ""}

                            {confirmEmailError !== "" && emailError === "" ? <div className='dds__message-bar dds__message-bar--warning icon email_error'><div className="dds__message-bar__icon">
                                <i className="dds__icon dds__icon--alert-notice"></i>
                            </div>{confirmEmailError}</div> : ""}

                            {emailError === "" && confirmEmailError === "" && matchEmailError !== "" ? <div className='dds__message-bar dds__message-bar--warning Email_error'><div className="dds__message-bar__icon">
                                <i className="dds__icon dds__icon--alert-notice"></i>
                            </div>{matchEmailError}</div> : ""}

                            {captchaError !== "" ? <div className='dds__message-bar dds__message-bar--warning Email_error'><div className="dds__message-bar__icon">
                                <i className="dds__icon dds__icon--alert-notice"></i>
                            </div>{captchaError}</div> : ""}
                            {signUpSuccess !== "" ? <div className='dds__message-bar dds__message-bar--success '><div className="dds__message-bar__icon">
                                <i className="dds__icon dds__icon--alert-check-sqr"></i>
                            </div>{signUpSuccess}</div> : ""}
                            {signUpError !== "" ? <div className='dds__message-bar dds__message-bar--warning Email_error'><div className="dds__message-bar__icon">
                                <i className="dds__icon dds__icon--alert-notice"></i>
                            </div>{signUpError}</div> : ""}
                            <form name="signUpForm" >
                                <fieldset disabled={loadingFlag}>
                                    <legend className="dds__sr-only">Email Sign Up Form</legend>
                                    {loadingFlag ? <div>
                                        <img className="loading" alt="Loading..." />
                                    </div> : ""}
                                    <div className="dds__row dds__my-4">
                                        <label className="dds__col--md-4 dds__col--sm-12 dds__col--xs-12" id="lblSigninFirstName" htmlFor="firstName">{renderTextLabel("esp_email_textbox_placeholder_firstname")}</label>
                                        <div className="dds__col--md-7 dds__col--sm-12 dds__col--xs-12">
                                            <input type='text' className="dds__input-text" id="firstName" name="firstName" aria-labelledby="lblSigninFirstName" maxLength="50" onChange={firstName_fn} onBlur={validateFirstName} />
                                        </div>
                                    </div>
                                    <div className="dds__row dds__my-4">
                                        <label className="dds__col--md-4 dds__col--sm-12 dds__col--xs-12" id="lblSigninLastName" htmlFor="lastName">{renderTextLabel("esp_email_textbox_placeholder_lastname")}</label>
                                        <div className="dds__col--md-7 dds__col--sm-12 dds__col--xs-12">
                                            <input type='text' className="dds__input-text" id="lastName" name="lastName" aria-labelledby="lblSigninLastName" maxLength="50" onChange={lastName_fn} onBlur={validateLasttName} />
                                        </div>
                                    </div>
                                    <div className="dds__row dds__my-4">
                                        <label className="dds__col--md-4 dds__col--sm-12 dds__col--xs-12 requiredLabel" id="lblSignupEmailAddress" htmlFor="emailAddress">{renderTextLabel("esp_email_textbox_placeholder_emailAddress")}</label>
                                        <div className="dds__col--md-7 dds__col--sm-12 dds__col--xs-12">
                                            <input type="email" id="emailAddress" name="emailAddress" aria-labelledby="lblSignupEmailAddress" maxLength="250" onChange={emailAddress_fn} onBlur={validateEmail} data-html="true" data-trigger="manual" data-placement="auto top" className="dds__input-text" />
                                        </div>
                                    </div>
                                    <div className="dds__row dds__my-4">
                                        <label className="dds__col--md-4 dds__col--sm-12 dds__col--xs-12 requiredLabel" id="lblConfirmEmail" htmlFor="confirmEmailAddress">{renderTextLabel("esp_email_textbox_placeholder_confirmEmailAddress")}</label>
                                        <div className="dds__col--md-7 dds__col--sm-12 dds__col--xs-12"><input type="email" id="confirmEmailAddress" aria-labelledby="lblConfirmEmail" maxLength="250" onChange={confirmEmailAddress_fn} onBlur={validateConfirmEmail} data-html="true" data-trigger="manual" data-placement="auto top" className="dds__input-text" /></div>
                                    </div>
                                    <div className="dds__row dds__my-4">
                                        <label className="dds__col--md-4 dds__col--sm-12 dds__col--xs-12 requiredLabel">{renderTextLabel("esp_email_Label_Captcha_Text")}</label>
                                        <div className="dds__col--md-8 dds__col--sm-6 dds__col--xs-6 dds__d-flex dds__align-items-center">
                                            <img src={imageSrc} id="img_captcha" className="img_captcha" alt="CAPTCHA verification code" />
                                            <span title="Refresh captcha" className="img_refresh_captcha dds__mx-2" onClick={handlerefreshCaptcha} role="button" tabIndex="0" aria-label="Refresh CAPTCHA code" onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handlerefreshCaptcha(); } }}> &nbsp;</span>
                                            <button type="button" style={{ backgroundColor: '#fff', color: '#65b1ef' }} onClick={handleCaptchaAudio} title="Listen to captcha" className="dds__btn dds__border-0 " aria-label="Listen to captcha">
                                                <svg id="dds__icon--audio-speaker-on" viewBox="0 0 32 32" width="32" height="28" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6 11h-5.36v10h5.36l6.5 7.2 4.32 0.82v-26l-4.32 0.78-6.5 7.2zM14.68 5.56v20.9l-1.080-0.22-6.64-7.3h-4.2v-5.82h4.2l6.64-7.36zM22.48 0.9l-1.020 1.78c4.652 2.693 7.731 7.647 7.731 13.32s-3.079 10.627-7.658 13.281l-0.074 0.039 1.020 1.78c5.279-3.050 8.774-8.667 8.774-15.1s-3.495-12.050-8.691-15.055l-0.084-0.045zM25 16c0-0.031 0-0.067 0-0.104 0-3.775-1.922-7.1-4.841-9.052l-0.040-0.025-1.080 1.74c2.423 1.589 4 4.293 4 7.365 0 0.026-0 0.053-0 0.079l0-0.004c0 0.035 0.001 0.077 0.001 0.118 0 3.010-1.518 5.666-3.831 7.242l-0.030 0.020 1.1 1.72c2.867-1.98 4.721-5.247 4.721-8.948 0-0.053-0-0.107-0.001-0.16l0 0.008z" />
                                                </svg>
                                            </button>
                                            <audio id="audio"></audio>
                                        </div>
                                    </div>
                                    <div className="dds__row dds__my-4">
                                        <label className="dds__col--md-4 dds__col--sm-12 dds__col--xs-12"></label>
                                        <div className="dds__col--md-7 dds__col--sm-12 dds__col--xs-12"><input type="text" id="captchaText" onChange={validateCaptcha_fn} onBlur={validateCaptchaFormat} data-trigger="manual" data-placement="auto top" className="dds__input-text" name="captcha" /></div>
                                    </div>
                                    <div className="dds__row  centerTextDiv">
                                        <dell-pmc-ncm data-locale={`${language}-${country}`} data-wsid={WEBSOURCESID}></dell-pmc-ncm></div>
                                    <div className="dds__row centerTextDiv">
                                        <button type="button" onClick={handleValidateCaptcha} id="signUpButton" disabled={isEnabled} className="dds__button dds__button-primary">{renderTextLabel("esp_email_button_signUp_button")}</button>
                                    </div>
                                    <div className="dds__row centerTextDiv">
                                        <p className="space20"> {renderTextLabel("esp_email_offers_label_textStart")} <a id="eui" href={'https://www.dell.com/preferences?c=' + country + '&l=' + language} aria-label="Manage your email preferences on Dell preferences page"><u> {renderTextLabel("esp_email_offers_link_textHere")} </u></a> {renderTextLabel("esp_email_offers_label_textEnd")} </p>
                                        <br />
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SignUp
